import { render, staticRenderFns } from "./LearningUnitProgress.vue?vue&type=template&id=135718c5&scoped=true&"
import script from "./LearningUnitProgress.vue?vue&type=script&lang=js&"
export * from "./LearningUnitProgress.vue?vue&type=script&lang=js&"
import style0 from "./LearningUnitProgress.vue?vue&type=style&index=0&id=135718c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135718c5",
  null
  
)

export default component.exports